import getCorrelationId from '../helpers/getCorrelationId'
import uuidv1 from 'uuid'
import shajs from 'sha.js'

const correlationId = getCorrelationId()

// Create another correlationId to be used specifically for Form ID.
const aoFormId = uuidv1()

export const formViewed = (stepName = '', stepNumber = 1) => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'FormViewed', {
      '@type': 'redventures.usertracking.v3.FormViewed',
      correlationId,
      formContext: {
        formType: window.remarketingId ? 'ApprovalOdds - SSN' : 'ApprovalOdds',
        formName: 'ApprovalOdds',
        formId: aoFormId
      },
      stepContext: {
        stepName,
        stepNumber
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const formStarted = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'FormStarted', {
      '@type': 'redventures.usertracking.v3.FormStarted',
      correlationId,
      formContext: {
        formType: window.remarketingId ? 'ApprovalOdds - SSN' : 'ApprovalOdds',
        formName: 'ApprovalOdds',
        formId: aoFormId
      },
      stepContext: {
        stepName: 'Names',
        stepNumber: 1
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const formContinued = (stepName = '', stepNumber = 1) => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'FormContinued', {
      '@type': 'redventures.usertracking.v3.FormContinued',
      correlationId,
      formContext: {
        formType: 'ApprovalOdds',
        formName: 'ApprovalOdds',
        formId: aoFormId
      },
      stepContext: {
        stepId: uuidv1(),
        stepName,
        stepNumber
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const formSubmitted = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'FormSubmitted', {
      '@type': 'redventures.usertracking.v3.FormSubmitted',
      correlationId,
      formContext: {
        formType: window.remarketingId ? 'ApprovalOdds - SSN' : 'ApprovalOdds',
        formName: 'ApprovalOdds',
        formId: aoFormId
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const coreIdentify = email => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'Identify', {
      '@type': 'core.Identify.v1',
      correlationId,
      traits: {
        email
      },
      userId: shajs('sha256')
        .update(email)
        .digest('hex')
    })
  } catch (error) {
    // Do nothing.
  }
}

export const fieldInputted = userInputField => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'FieldInputted', {
      '@type': 'redventures.usertracking.v3.FieldInputted',
      correlationId,
      formContext: {
        formType: window.remarketingId ? 'ApprovalOdds - SSN' : 'ApprovalOdds',
        formName: 'ApprovalOdds',
        formId: aoFormId
      },
      userInputField
    })
  } catch (error) {
    // Do nothing.
  }
}

export const fieldSelected = field => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'FieldSelected', {
      '@type': 'redventures.usertracking.v3.FieldSelected',
      userInputField: {
        fieldLabel: field,
        fieldName: field,
        fieldType: field,
        fieldValue: field
      },
      formContext: {
        formType: 'ApprovalOdds',
        formName: 'ApprovalOdds',
        formId: aoFormId
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const loaderViewed = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementViewed', {
      '@type': 'redventures.usertracking.v3.ElementViewed',
      correlationId,
      webElement: {
        elementType: 'Modal',
        location: 'Section',
        name: window.remarketingId
          ? 'ApprovalOdds - SSN Loading'
          : 'Approval Odds Loading',
        position: 'Top',
        text: 'Loading'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const errorModalViewed = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementViewed', {
      '@type': 'redventures.usertracking.v3.ElementViewed',
      correlationId,
      webElement: {
        elementType: 'Modal',
        location: 'Section',
        name: window.remarketingId
          ? 'ApprovalOdds - SSN Error Modal'
          : 'Approval Odds Error Modal',
        position: 'Top',
        text: 'Sorry, we couldnt access your approval odds'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const errorModalRestartClicked = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementClicked', {
      '@type': 'redventures.usertracking.v3.ElementClicked',
      correlationId,
      webElement: {
        elementType: 'Button',
        location: 'Section',
        name: 'Button',
        position: 'Bottom',
        text: 'Start Over'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const closeModalClicked = (name = 'Button') => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementClicked', {
      '@type': 'redventures.usertracking.v3.ElementClicked',
      correlationId,
      webElement: {
        elementType: 'Button',
        location: 'Section',
        name,
        position: 'Top',
        text: 'Close'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const aoButtonViewed = (
  position = '1',
  location = 'Grid',
  name = 'See your approval odds'
) => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementViewed', {
      '@type': 'redventures.usertracking.v3.ElementViewed',
      correlationId,
      webElement: {
        elementType: 'button',
        location,
        name,
        position: String(position),
        text: 'See your approval odds'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const aoButtonClicked = (
  position = '1',
  name = 'button',
  location = 'Grid'
) => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementClicked', {
      '@type': 'redventures.usertracking.v3.ElementClicked',
      correlationId,
      webElement: {
        elementType: 'button',
        location,
        name,
        position: String(position),
        text: 'See your approval odds'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const aoResultViewed = (
  position = '1',
  text = '',
  location = 'Grid',
  name = 'Approval Odds Results'
) => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementViewed', {
      '@type': 'redventures.usertracking.v3.ElementViewed',
      correlationId,
      webElement: {
        elementType: 'Button',
        location,
        name,
        position: String(position),
        text
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const aoProductListViewed = (product = []) => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ProductListViewed', {
      '@type': 'redventures.ecommerce.v1.ProductListViewed',
      correlationId,
      product,
      webContext: {
        page: {
          referrer: document.referrer || '',
          url: location.href || '',
          title: document.title || ''
        }
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const aoBannerClicked = () => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementClicked', {
      '@type': 'redventures.usertracking.v3.ElementClicked',
      correlationId,
      webElement: {
        elementType: 'Internallink',
        location: 'Hero',
        name: 'Approval Odds Banner',
        position: 'Top',
        text: 'Learn more'
      }
    })
  } catch (error) {
    // Do nothing.
  }
}

export const aoFilterClicked = (text = '', elementType = 'Button') => {
  try {
    // eslint-disable-next-line no-undef
    tagular('beam', 'ElementClicked', {
      '@type': 'redventures.usertracking.v3.ElementClicked',
      correlationId,
      webElement: {
        elementType,
        location: 'Grid',
        name: 'Filter',
        position: 'Top',
        text
      }
    })
  } catch (error) {
    // Do nothing.
  }
}
